import TrialLimitReachedModalModule from './Modal/TrialLimitReachedModal/modules/trialLimitReachedModal';
import TollFreeAndLocalModalModule from './Modal/TollFreeAndLocalModal/modules/tollFreeAndLocalModal';
import StarterConversationModule from './Starter/modules/starter';
import { defineStore } from 'pinia';

export const ConversationsModules = {
    TrialLimitReachedModalModule: defineStore(
        'TrialLimitReachedModalModule',
        TrialLimitReachedModalModule
    ),
    TollFreeAndLocalModalModule: defineStore(
        'TollFreeAndLocalModalModule',
        TollFreeAndLocalModalModule
    ),
    StarterConversationModule: defineStore('StarterConversationModule', StarterConversationModule),
};
